import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import InfoBar from '../../components/Navigation/InfoBar';
import useApi from '../../hooks/use-api';
import AddDationInstanceModal from '../../components/Modal/AddDationInstanceModal';
import { dationInstanceEndpoint } from '../../constants/routes';
import DationInstanceOverview from '../../components/Tables/DationInstances/DationInstanceOverview';
import * as ROUTES from '../../constants/routes';
import { useNavigate } from 'react-router-dom';

function DationInstancesListPage() {
	const navigate = useNavigate();

	const [show, setShow] = useState(false);
	const [body, setBody] = useState([]);

	// Getting extended fields for dationInstanceEndpoint()
	const [{ data }, fetchDationInstances] = useApi.get(`${dationInstanceEndpoint()}`, {
		expand: ['portal_admin'],
	});

	useEffect(() => {
		if (data) {
			const newBody = data.map((entry) => ({
				id: entry.id,
				name: entry.name,
			}));

			setBody(newBody);
		}
	}, [data]);

	return (
		<>
			<InfoBar />
			<div className="d-flex flex-row-reverse">
				<Button
					id="add-dation-instance"
					variant="outline-secondary"
					className="rounded-button p-1"
					type="button"
					onClick={() => setShow(true)}>
					<span className="glyphicons glyphicons-plus" style={{ position: 'relative', top: 3 }} />
				</Button>
			</div>
			<div className="col-12 col-xl-10 mx-auto pt-n5">
				<DationInstanceOverview
					dationInstances={body}
					handleRowClick={({ id }) => navigate(ROUTES.dationInstancePage(id))}
				/>
			</div>
			<AddDationInstanceModal setShow={setShow} show={show} handleSubmit={fetchDationInstances} />
		</>
	);
}

export default DationInstancesListPage;
